import { Component, Input, OnInit, AfterViewInit, OnChanges, ViewChild, Output, EventEmitter, SimpleChanges, } from '@angular/core';
import { Routes, Router } from '@angular/router';
import { RoutesService } from '../../services/routes.service';

import { HttpClient } from '@angular/common/http';
import { DxListComponent, DxTabPanelComponent, DxTextAreaComponent, DxTextBoxComponent, DxTreeViewComponent } from 'devextreme-angular';
import { NicaPrefMenuComponent } from '../nica-pref-menu/nica-pref-menu.component';
import { NicaMenuService } from '../../services/nica-menu.service';

import { Menu } from '../../class/appinterface';
import { ComponentService } from '../../services/component.service';
import { alert } from 'devextreme/ui/dialog';
import { Utenteservice } from '../../services/utente.service';


@Component({
  selector: 'app-nica-child-menu-list',
  templateUrl: './nica-child-menu-list.component.html',
  styleUrls: ['./nica-child-menu-list.component.css']
})



export class NicaChildMenuListComponent implements OnInit, OnChanges {

  mostra: boolean = false;

  listFields: Menu[];

  tabIndex: number = 0;
  scrollbarType = "always";
  loadingVisible: boolean = true
  /*******/
  selectAllModeVlaue = 'page';
  selectionModeValue = 'all';


  @Input() subMenu: Menu;
  @Input() thisShow: boolean
  @Input() menuType: string
  @Input() titleMenu: string
  @Output() reseted: EventEmitter<any> = new EventEmitter<any>();


  // @ViewChild(DxListComponent, { static: false }) wishList: DxListComponent
  // ===== or using a template reference variable =====

  @ViewChild("chillsList", { static: false }) chillsList: DxListComponent
  @ViewChild("searchInput", { static: false }) searchInput: DxTextBoxComponent
  @ViewChild("treeView", { static: false }) treeView: DxTreeViewComponent
  myDataCopy: Menu[];


  constructor(private ruote: Router, private http: HttpClient, private menuService: NicaMenuService, private componentService: ComponentService,
    private utente:Utenteservice
    ) { }


  ngOnChanges() {
    this.listFields = this.subMenu[0].items
    this.myDataCopy = [...this.subMenu[0].items];
    if (this.searchInput != undefined) {
      this.searchInput.instance.reset();
    }

    // or, this.myDataCopy = mainDataChange.currentValue;

  }

  ngAfterViewInit(){
    /* var items = this.listFields;
    for (var i = 0; i < items.length; i++) {
      this.chillsList.instance.collapseGroup(i);
    } */
  }

  ngOnInit() {
    
    this.listFields = this.subMenu[0].items;
    this.myDataCopy = [...this.subMenu[0].items];
    if (this.searchInput != undefined) {
      this.searchInput.instance.reset();
    }

    
  }

  resetSelected() {
    //const Items = ev.itemData;


  }


  aggiungiPreferiti(ev, item) {



    if (item.fav) {
      item.fav = false
    } else {
      item.fav = true; //imposto a true valore fav dell'item l'elemento
    }



    this.menuService.updatePreferiti(item)

    ev.event.stopPropagation();
  }



  rimuoviPreferiti(item, ev) {

    item.fav = false;

  }

  itemAction(ev) {

      
    const itemData = ev.itemData;

    

    if (itemData.controller == '') {
       alert('nessun componente attivo', 'Messaggio')
      return
    }
    
    if (itemData.controller == 'Causali2Component') {
      
      itemData.controller = 'EditAutocompleteComponent';
      ev.itemData.controller='EditAutocompleteComponent';
      //return
    }



    /* Con ruote*/
    let valueC
    let dataFilter;
    let titolo=''
    let  api
    let  service
    let breadcrumb
   let template='grid'
    let controller
    let descEvent=''
    //alert(itemData.controller,"www")
    if(itemData.controller=='Causali2Component') itemData.controller='EditAutocompleteComponent';
    switch (itemData.id) {
     
      case '087':
        api='CausaleRifiuti';
        service='CausaleRifiuti'
        titolo='Causali';
        breadcrumb='Causali';
        template="grid";
        
        break;
      case '085':
        api='soggetto';
        service='soggetto'
        titolo='Anagrafiche propri impianti';
        breadcrumb='Anagrafica azienda'
        controller= 'AnaSoggettoComponent'
        descEvent=''
        template="grid";
        valueC =
        {
          NostreAziende: 'S'
        }

        dataFilter =  {
          nsAzienda: true,
          NostreAziende: 'S'
        }
        break;
      case '043':
        api='soggetto';
        service='soggetto';
        titolo='Anagrafiche azienda';
        breadcrumb='Anagrafica azienda';
        template="grid";
        descEvent=''
        valueC =
        {
          NostreAziende: 'N',
          
        }
        dataFilter =  {
          nsAzienda: false,
          NostreAziende: 'N',
        }
        break;
      case '044':
        api='soggetto';
        service='soggetto';
        template="grid",
        descEvent=''
        valueC =
        {
          NostreAziende: 'N',
          
        }
        dataFilter =  {
          nsAzienda: false,
          NostreAziende: 'N',
        }
        break;
      case '045':
        api='soggetto';
        service='soggetto';
        template="grid",
        descEvent=''
        valueC =
        {
          NostreAziende: 'N',
          
        }
        dataFilter =  {
          nsAzienda: false,
          NostreAziende: 'N',
        }
        break;
        case '125': // Schede rifiuti Produttori        
          valueC = {
            tipoScheda: 'P',
            servizio:'SchedaRifiuto'

          }
          break;
          case '126': // Schede rifiuti Produttori
          valueC = {
            tipoScheda: 'G',
            servizio:'SchedaRifiutoG'
          }
          break;          
        case '200':   
        api='';
        service='gestioneAziendaAdmin'
        titolo='Gestione info Azienda';
        breadcrumb='Info azienda';
        template="form";
        valueC =        
        {
          idLicenza:this.utente.InfoDatiUtenteConnesso.licenza,
        }           
        dataFilter =  {
          titolo:'Gestione Utenti e Permessi',
          idLicenza:this.utente.InfoDatiUtenteConnesso.licenza
        }
        break;
      case '122':{        
        api='ConfigurazioniModuli';
        service='ConfigurazioniModuli';
        template="grid"
       break;
      }
      case '090':{
        api='MovimentoRifiuti';
        service='movimentiRifiuto';
        template="grid"
        break;
      }
      case '134':{
        api='';
        service='';
        template="grid"
        break;
      }
      case '204':{ //FORMULARI
        api='MovimentoRifiuti';
        service='movimentiRifiuto';
        template="grid",
        breadcrumb='Formulari emessi'
        break;
      }
      case '206':{

        titolo='Stampa Registri di Carico e Scarico Aziendale';

        service = 'stampaRegistri';
        template="stampaRegistri";

      }break;
      case '134':{
      }break;
      case '207':{

        titolo='Generatore di anagrafiche';
        service = 'generaConfigurazione';
        template="grid";

      }break;
    }

    if(typeof itemData.text == 'undefined'){
      return 
    }
    
    let pathItem = itemData.text.toLowerCase().replace(/[^a-zA-Z ]/g, '');
    pathItem = pathItem.replace(/\s/g, '-');

    //console.log(itemData)
    
    let params = {
      
      api: api,
      service: service,
      titolo:titolo!='' ? titolo: itemData.text,
      breadcrumb:breadcrumb,
      currentTabId: itemData.id,
      currentTabName: itemData.text,
      queryFilter: JSON.stringify(valueC),
      data: JSON.stringify(dataFilter),
      filter: JSON.stringify(dataFilter),
      helpDoc: itemData.contextHelp,
      componentName: controller,
      templateView:template,
      descEvent:descEvent
    }
   
    //console.log("pathItem="+params)
    this.ruote.navigate(
      ['main/' + pathItem],
      {
        queryParams: params,
        skipLocationChange: true,
        replaceUrl: true
      }
    )
      .then(data => {
        //console.log(data)
        this.reseted.emit(itemData)

    
      })
      .catch(e => {
        alert(e, '')
        //console.log('Route non exists, redirection is error');
        //this.ruote.navigate(['main/dashboard'])
      });

    //this.reseted.emit(ev)


  }

  searchData(e) {

    let searchText = e.value

    console.log(searchText)

    if (searchText == '') {
      this.listFields = this.subMenu[0].items
      this.reseted.emit(e)
      return;
    }

    if (searchText.length >= 4) {
      setTimeout(() => {
        const items = this.myDataCopy

        let res = this.fetchObject(items, [], searchText);
        this.listFields = res;


      }, 500);

    }


  }

  /********/
  fetchObject(object, arrayFinal, sText, key = 0) {

    for (let x = 0; x < object.length; x++) {

      if (object[x].items) {
        /*let arrayItems = object[x].items
        
        this.fetchObject(arrayItems,object[x],sText,x)*/

        /****
         *  disabled: false
            id: "R-A"
            items: (15) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
            key: "Operazione Giornaliere"
            visible: true
         * 
         * 
         * 
         */

        arrayFinal.push({
          disabled: object[x].disabled,
          key: object[x].key,
          id: object[x].id,
          visible: object[x].visible,
          items: []
        })


        this.fetchObject(object[x].items, arrayFinal, sText, x)
      } else {
        if (object[x].text.toLowerCase().includes(sText.toLowerCase())) {
          arrayFinal[key].items.push(object[x])
          this.chillsList.instance.expandGroup(key);
        }


      }

    }
    return arrayFinal
    //this.chillsList.instance.getDataSource().load();


  }
  showSubItem(ev) {

    if (ev.key) {
      let expandItemNext = true;


      this.treeView.instance.getNodes()
        .map((node) => {

          if (node.expanded) {
            this.treeView.instance.collapseItem(node.itemData)
            expandItemNext = node.itemData.key

            return
          }

        });

      if (expandItemNext != ev.key) {
        this.treeView.instance.expandItem(ev)
      }
    }

  }

  onContentReady(e) {

    
    setTimeout(() => {
      var items = e.component.option("items");
      for (var i = 0; i < items.length; i++) {
        e.component.collapseGroup(i);
      }
      
    }, 100);




  }

}

